export const comments_5618855 = {"data":{"data":[],"links":{}}}